module.exports = __webpack_public_path__ + "img/generic_user.c938639b.png";